import { gql } from "@apollo/client";

const CREATE_SHIPMENT = gql`
  mutation createShipment($input: CreateShipmentInput!) {
    createShipment(input: $input) {
      __typename
      ... on Shipment {
        id
        shipment_date
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const UPDATE_SHIPMENT = gql`
  mutation updateShipment($input: UpdateShipmentInput!) {
    updateShipment(input: $input) {
      __typename
      ... on Shipment {
        id
        shipment_date
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

const DELETE_SHIPMENT = gql`
  mutation deleteShipment($id: Float!) {
    deleteShipment(id: $id) {
      __typename
      ... on Shipment {
        id
        shipment_date
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;

export { CREATE_SHIPMENT, UPDATE_SHIPMENT, DELETE_SHIPMENT };
